import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { LIVE_ACCOUNT_URL } from "../lib/api";
import { fadeVariants, VIEWPORT_ONCE_TIGHT } from "../lib/motion";

const ctaEnter = fadeVariants({ y: 30, duration: 0.7 });

export default function BottomCTA() {
    return (
        <section
            data-testid="bottom-cta-section"
            className="relative py-24 lg:py-32 overflow-hidden"
        >
            <div className="absolute inset-0 -z-10 xpo-grid-bg opacity-50" />
            <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[700px] h-[700px] xpo-glow-mint blur-3xl -z-10 opacity-60" />

            <div className="xpo-container">
                <motion.div
                    variants={ctaEnter}
                    initial="hidden"
                    whileInView="visible"
                    viewport={VIEWPORT_ONCE_TIGHT}
                    className="text-center max-w-3xl mx-auto"
                >
                    <p className="overline mb-4">Ready when you are</p>
                    <h2 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white tracking-tight leading-[1.05]">
                        Stop watching the chart.
                        <br />
                        <span className="text-[#A6E3DC]">Start trading it.</span>
                    </h2>
                    <p className="text-slate-400 text-lg mt-6 leading-relaxed">
                        Open an account in minutes. Fund it when you're ready.
                        Trade with discipline.
                    </p>
                    <div className="flex flex-wrap gap-4 justify-center mt-10">
                        <a
                            data-testid="bottom-cta-open-live"
                            href={LIVE_ACCOUNT_URL}
                            target="_blank"
                            rel="noreferrer"
                            className="btn-primary"
                        >
                            Open Live Account <ArrowUpRight size={18} />
                        </a>
                        <a
                            data-testid="bottom-cta-contact"
                            href="/contact"
                            className="btn-secondary"
                        >
                            Talk to our team
                        </a>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
